import { Button } from "./ui/button";
import { companyInfo, images } from "../data/mock";
import { ArrowRight, CalendarCheck, Shield, Clock, Award } from "lucide-react";

export const HeroSection = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[100vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Professional HVAC installation - India's leading commercial air conditioning contractor"
          className="w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#0F2340]/95 via-[#0F2340]/85 to-[#0F2340]/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F2340]/70 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 w-full">
        <div className="max-w-2xl">
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/15 rounded-full px-4 py-1.5 mb-8 animate-fade-in">
              <Shield className="w-4 h-4 text-accent-400" />
              <span className="text-sm text-white/90 font-medium">
                {companyInfo.ventureOf}
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-slide-up">
              Complete HVAC Solutions.
              <span className="block text-accent-400 mt-2">
                From Homes to High-Rise Complexes.
              </span>
            </h1>

            {/* Subheading */}
            <p className="text-lg sm:text-xl text-white/75 leading-relaxed mb-10 max-w-xl animate-slide-up-delay">
              India's premier HVAC solutions provider. Expertise in VRF/VRV systems, centralized air conditioning, and turnkey commercial HVAC projects for malls, offices &amp; industrial facilities. Four decades of engineering excellence.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mb-14 animate-slide-up-delay-2">
              <Button
                onClick={() => scrollTo("#cta")}
                className="bg-accent-500 hover:bg-accent-600 text-white text-base px-7 h-12 rounded-xl shadow-lg shadow-accent-500/25 transition-all duration-200 hover:shadow-xl hover:shadow-accent-500/30 hover:-translate-y-0.5">

                Request a Quote
                <ArrowRight className="w-4.5 h-4.5 ml-2" />
              </Button>
              <Button
                onClick={() => scrollTo("#cta")}
                variant="outline"
                className="border-white/25 bg-white/5 backdrop-blur-sm text-white hover:bg-white/15 hover:text-white text-base px-7 h-12 rounded-xl transition-all duration-200 hover:-translate-y-0.5">

                <CalendarCheck className="w-4.5 h-4.5 mr-2" />
                Book Service Now
              </Button>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap items-center gap-6 animate-fade-in-delay">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Award className="w-4.5 h-4.5 text-accent-400" />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">40+ Years</p>
                  <p className="text-white/50 text-xs">Industry Experience</p>
                </div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block" />
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Shield className="w-4.5 h-4.5 text-accent-400" />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">2,500+</p>
                  <p className="text-white/50 text-xs">Projects Delivered</p>
                </div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block" />
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Clock className="w-4.5 h-4.5 text-accent-400" />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">50+ Cities</p>
                  <p className="text-white/50 text-xs">Pan-India Presence</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>);

};